// test1896
(1896 && 0);
